import React, { Fragment } from 'react';
import { FunnelMetrics, FunnelStep } from '../../types/throughput';
import { Card, CardHeader, CardTitle } from '../ui/Card';
import { ArrowRight } from 'lucide-react';
interface ThroughputFunnelProps {
  metrics: FunnelMetrics[];
}
const KEY_STEPS: FunnelStep[] = ['Created', 'Converted', 'Submitted to UW', 'Closing Scheduled', 'Funded'];
const STEP_LABELS: Partial<Record<FunnelStep, string>> = {
  Created: 'Claimed',
  'Closing Scheduled': 'CTC'
};
export function ThroughputFunnel({
  metrics
}: ThroughputFunnelProps) {
  const keyMetrics = metrics.filter(m => KEY_STEPS.includes(m.step));
  return <Card className="mb-8 p-0 overflow-hidden" noPadding data-id="element-106">
      <CardHeader bordered className="!mb-0" data-id="element-107">
        <CardTitle data-id="element-108">Conversion Funnel</CardTitle>
      </CardHeader>

      <div className="p-8" data-id="element-109">
        <div className="flex items-center justify-between max-w-5xl mx-auto" data-id="element-110">
          {keyMetrics.map((metric, index) => {
          const isLast = index === keyMetrics.length - 1;
          const nextMetric = !isLast ? keyMetrics[index + 1] : null;
          const stepConversion = nextMetric && metric.count > 0 ? (nextMetric.count / metric.count * 100).toFixed(0) : '0';
          const label = STEP_LABELS[metric.step] || metric.step;
          return <Fragment key={metric.step} data-id="element-111">
                <div className="flex flex-col items-center text-center flex-1" data-id="element-112">
                  <div className="text-sm font-medium text-[#706E6B] mb-3" data-id="element-113">
                    {label}
                  </div>
                  <div className="text-3xl font-semibold text-[#181818] mb-2" data-id="element-114">
                    {metric.count.toLocaleString()}
                  </div>
                  {index > 0 && <div className="text-xs text-[#706E6B]" data-id="element-115">
                      {metric.overallConversionRate.toFixed(1)}% of total
                    </div>}
                </div>

                {!isLast && <div className="flex flex-col items-center justify-center px-4" data-id="element-116">
                    <ArrowRight className="h-5 w-5 text-[#CCCCCC] mb-1" data-id="element-117" />
                    <span className="text-xs font-medium text-[#706E6B] bg-[#F5F5F5] px-2 py-1 rounded-full" data-id="element-118">
                      {stepConversion}%
                    </span>
                  </div>}
              </Fragment>;
        })}
        </div>
      </div>
    </Card>;
}